import { createFileRoute } from "@tanstack/react-router";
import { CITY_PAGES } from "@/content/localPages";
import { localPageHead } from "@/content/localPageHead";
import { LocalPageView } from "@/components/marketing/LocalPageView";

export const Route = createFileRoute("/scottsdale-ppc-agency")({
  head: () => localPageHead(CITY_PAGES.scottsdale!),
  component: ScottsdalePage,
});

function ScottsdalePage() {
  return <LocalPageView page={CITY_PAGES.scottsdale!} />;
}
